import { Fragment, useCallback, useEffect } from "react";
import { ModalProps } from "../@types/modal";
import { Backdrop, ModalContainer } from "./modal.styled";

const ESC_KEY_CODE = 27;
const EVENT_TYPE = 'keydown';

const Modal: React.FC<ModalProps> = ({ children, showModal, closeOnEsc, onClose, backdropToggle, backdropProps, zIndex, ...props }) => {

    const handleKeyPressed = useCallback((event) => {
        if (showModal && closeOnEsc && event.keyCode === ESC_KEY_CODE && onClose) {
            onClose();
        }
    }, [showModal, closeOnEsc, onClose]);

    useEffect(() => {
        if(closeOnEsc){
            document.addEventListener(EVENT_TYPE, handleKeyPressed, false);
        }

        return () => {
            document.removeEventListener(EVENT_TYPE, handleKeyPressed, false);
        };
    }, [closeOnEsc, handleKeyPressed]);

    useEffect(() => {
        document.body.style.overflow = showModal ? 'hidden' : 'unset';
    }, [showModal]);

    return showModal ? (
        <Fragment>
            <Backdrop {...backdropProps} zIndex={zIndex} onClick={backdropToggle} />
            <ModalContainer {...props} zIndex={zIndex}>
                {children}
            </ModalContainer>
        </Fragment>
    ) : null;
};

export default Modal;
